import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '../../useAddress'

const HeatingEnergy = () => {
  const { t, updateAddress, energyLandscape, heatingEnergy, heatingOptions, errors } = useAddress()
  const error = getError('heatingMode', errors)

  return (
    <SDFormControl plainLabel error={error}>
      <SDSelect
        label={t('subscriptionTools:estimator.heating_mode.label')}
        translationsPath='subscriptionForm:address_module.heating_types.'
        newTranslations={true}
        optionsList={heatingOptions}
        onChangeHandler={params =>
          updateAddress({
            heatingEnergy: params.option?.id,
            energyLandscape: {
              ...energyLandscape,
              heatPump: params.option?.id !== 'elec' ? false : energyLandscape.heatPump,
            },
          })
        }
        selectedValue={heatingEnergy ? heatingEnergy.toString() : ''}
        hasError={!!error}
      />
    </SDFormControl>
  )
}
export default HeatingEnergy
